import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * @description 登录
     * @param {Object} data 登录携带的信息
     */
    account: function account() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/login/account',
        data: data
      });
    },

    /**
     * @description 入驻状态
     */
    checkTokenStatus: function checkTokenStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var token = YL.cookies.get(process.env.VUE_APP_LOGIN_TOKEN);

      if (!token) {
        return Promise.reject('token is empty');
      } // 接口请求


      return request({
        url: '/store/checkTokenStatus',
        data: data
      });
    },

    /**
     * @description 获取上传token
     */
    getUploadToken: function getUploadToken() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/store/getUploadToken',
        data: data
      });
    },
    QN_UPLOAD: function QN_UPLOAD() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var formdata, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formdata = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                _context.next = 3;
                return axios.post(process.env.VUE_APP_QI_NIU, formdata);

              case 3:
                res = _context.sent;
                console.warn('upload', res);
                return _context.abrupt("return", process.env.VUE_APP_IMG_BASE + res.data.key);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 修改手机号码
     */
    updatePhone: function updatePhone() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/store/updatePhone',
        data: data
      });
    },

    /**
     * @description 修改手机号码 - 发生验证码
     */
    updatePhoneVerifyCode: function updatePhoneVerifyCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/store/updatePhoneVerifyCode',
        data: data
      });
    },

    /**
     * @description 验证当前手机号码 - 发生验证码
     */
    verifyPhoneCode: function verifyPhoneCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/store/verifyPhoneCode',
        data: data
      });
    },

    /**
     * @description 找回密码
     */
    findPassword: function findPassword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      console.log(request);
      return request({
        url: '/store/findPassword',
        data: data
      });
    },

    /**
     * @description 找回密码 - 发生验证码
     */
    findPasswordVerifyCode: function findPasswordVerifyCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/store/findPasswordVerifyCode',
        data: data
      });
    },

    /**
     * @description 修改密码
     */
    updatePassword: function updatePassword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/store/updatePassword',
        data: data
      });
    },

    /**
     * @description 获取IM签名
     */
    imUserSign: function imUserSign() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/index/imUserSign',
        data: data
      });
    }
  };
});